module.exports = __webpack_public_path__ + "static/media/top-comment.3f84f555.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/top-comment.png
// module id = 554
// module chunks = 6